export const INFO_CIRCLE = ({ height=16, width=16 }) => {
return (
<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_2126_49072)">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 1.83325C4.59416 1.83325 1.83325 4.59416 1.83325 7.99992C1.83325 11.4057 4.59416 14.1666 7.99992 14.1666C11.4057 14.1666 14.1666 11.4057 14.1666 7.99992C14.1666 4.59416 11.4057 1.83325 7.99992 1.83325ZM0.833252 7.99992C0.833252 4.04188 4.04188 0.833252 7.99992 0.833252C11.958 0.833252 15.1666 4.04188 15.1666 7.99992C15.1666 11.958 11.958 15.1666 7.99992 15.1666C4.04188 15.1666 0.833252 11.958 0.833252 7.99992ZM7.49992 5.33325C7.49992 5.05711 7.72378 4.83325 7.99992 4.83325H8.00659C8.28273 4.83325 8.50659 5.05711 8.50659 5.33325C8.50659 5.60939 8.28273 5.83325 8.00659 5.83325H7.99992C7.72378 5.83325 7.49992 5.60939 7.49992 5.33325ZM7.99992 7C8.27606 7 8.49992 7.22386 8.49992 7.5V11.5C8.49992 11.7761 8.27606 12 7.99992 12C7.72378 12 7.49992 11.7761 7.49992 11.5V7.5C7.49992 7.22386 7.72378 7 7.99992 7Z" fill="#17142A"/>
  </g>
  <defs>
    <clipPath id="clip0_2126_49072">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
)
}
